import * as React from 'react';
//Material UI
import {Grid} from '@material-ui/core';
//FluentUI
import { 
  Sticky,
  ScrollablePane,
  Label,
  SearchBox,
  CommandBar,
  Breadcrumb,
  Toggle,
  DetailsRow } from '@fluentui/react';
import {
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode,
} from 'office-ui-fabric-react/lib/DetailsList';
//Components
import {InfoCallout} from './components';
import {DateSelect, PartnerSelect} from '../../../../../../components/Inputs';
import {EditPartner,EditPartnerContacts,ViewPartnerContacts} from '../../../components';
import {Pagination} from '../../../../../../components';
import {apiRequest} from './apiRequest';

//Models
import data from './data';
//Theme
import style from './style';
import { withStyles } from '@material-ui/core';
import AddContact from '../../Modals/AddContact';

export class PartnerTendersList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      //table rows
      items: [],
      columns: data.setColumns(this,'default'),
      isCompactMode: false,
      //filter
      filteredItems:[],
      isFiltered:false,
      //pagination
      first:0,
      last:0,
      //request
      loading:true,
      //modals
      modal:{
        edit:false,
        new:false,
        editContact:false,
        viewContact:false,
      },
      //commands
      commandItems: data.setCommandItems(this),
      farCommandItems:data.setFarCommandItems(this),
      info:false
    };

    this._onItemInvoked  = this._onItemInvoked.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
  }

  componentDidMount(){
    const {selectedPartner} = this.props;
    apiRequest.getTenders(this,selectedPartner.key);
  }


  //*Set clicked row*//
  handleClick(item){
    this.props.onSelect(item)
  }
  //**//

  //*Handle modals*//

  handleClose(){
    this.setState({
      modal:{
        edit:false,
        new:false
      }
    });
  }

  handleOpen(props){
    this.setState((prevState)=>({
      modal:{
        ...prevState.modal,
        [props]:true
      }
    }));
  }
  //**//

  //*Helper methods*//
  handleOpenInfo = () =>{
    this.setState({
      info:true
    })
  }

  handleCloseInfo = () =>{
    this.setState({
      info:false
    })
  }
  //**//


  render() {
    const { columns,info, isCompactMode,first,last,loading, items,commandItems,farCommandItems,filteredItems,isFiltered,modal } = this.state;
    const {classes,navItems,tender,selectedPartner,setSelectedPartner,onRefreshPartners} = this.props;
    return (
      <div>
        {modal.edit===true && <EditPartner onRefreshPartners={onRefreshPartners} setSelectedPartner={setSelectedPartner} selectedPartner={selectedPartner} open={modal.edit} hideModal={this.handleClose}/>}
        {modal.new===true && <AddContact selectedPartner={selectedPartner} open={modal.new} hideModal={this.handleClose}/>}
        {modal.editContact===true && <EditPartnerContacts setSelectedPartner={setSelectedPartner} selectedPartner={selectedPartner} open={modal.editContact} hideModal={this.handleClose}/>}
        {modal.viewContact===true && <ViewPartnerContacts setSelectedPartner={setSelectedPartner} selectedPartner={selectedPartner} open={modal.viewContact} hideModal={this.handleClose}/>}
        {info===true && <InfoCallout  onClose={()=>this.handleCloseInfo()} buttonId={`bt-info`} />}  
        {navItems!=null && 
        <div className={classes.breadcrumb}>
          <Breadcrumb
            items={navItems}
            maxDisplayedItems={10}
          />
        </div>
        }
        <CommandBar
          items={commandItems}
          farItems={farCommandItems}
        />
         {tender!=null && <div className={classes.header}>
            <Grid spacing={2} container>
              <Grid xs={6} sm={6} md={6} lg={3} xl={3} item>
                <Label>Beadási időszak kezdete</Label>
                <DateSelect value={tender.startDate} disabled={true}/>
              </Grid>
              <Grid xs={6}  sm={6} md={6} lg={3} xl={3} item>
                <Label>Beadási időszak vége</Label>
                <DateSelect value={tender.endDate} disabled={true}/>
              </Grid>
              <Grid xs={12} sm={12} md={12} lg={5} xl={5} item>
                <Label>Kiválasztott partnerek</Label>
                <PartnerSelect tags={tender.partners} disabled={true} />
              </Grid>
              <Grid xs={12} sm={12} md={4} lg={2} xl={2} item>
                <Toggle disabled checked={tender.showBestOffer} label="Legjobb ajánlat mutatása" defaultChecked onText="Igen" offText="Nem" />
              </Grid>                    
            </Grid>
        </div>}
        <div className={classes.table}>
          <div style={style.fluentUI.controlWrapper}>
            <SearchBox style={style.fluentUI.search} placeholder="Keresés..." onChange={this._onChangeText} />
          </div>
          <div style={style.fluentUI.tableWrapper}>
          <ScrollablePane>
            <DetailsList
              items={isFiltered ? filteredItems.slice(first,last) : items.slice(first,last)}
              compact={isCompactMode}
              columns={columns}
              selectionMode={SelectionMode.none}
              getKey={this._getKey}
              setKey="none"
              layoutMode={DetailsListLayoutMode.justified}
              onRenderDetailsHeader={
                (detailsHeaderProps, defaultRender) => (
                  <Sticky>
                    {defaultRender(detailsHeaderProps)}
                  </Sticky>
                ) }
              isHeaderVisible={true}
              onItemInvoked={this._onItemInvoked}
              onRenderRow={this.onRenderColumnListRow}
            />
            </ScrollablePane>
          </div>
          <Pagination loading={loading} parent={this} length={isFiltered ? filteredItems.length : items.length}/>
        </div>
      </div>
    );
  }

  
  //*To render table rows*//

  onRenderColumnListRow= (props) => {
    const customStyles = {};
    if (props) {
        customStyles.root = style.fluentUI.tableRow;
        return <DetailsRow {...props} styles={customStyles}/>;
    }
    return null;
  };


   _getKey(item, index) {
    return item.key;
  }

   _onChangeCompactMode = (ev, checked) => {
    this.setState({ isCompactMode: checked });
  };

  _onChangeText = (ev, text) => {
    if(text!=='' && text!==null && text!==undefined){
      this.setState({
        isFiltered:true
      });
    }else{
     this.setState({
       isFiltered:true
     });
    }
    const {items} = this.state;
     this.setState({
       filteredItems: text ? items.filter(i => i.name.toLowerCase().indexOf(text.toLowerCase()) > -1) : items,
     });
  };

  _onItemInvoked(item) {
    this.props.onSelect(item);
 }


   _onColumnClick = (ev, column) => {
    const { columns, items } = this.state;
    const newColumns= columns.slice();
    const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
    newColumns.forEach((newCol) => {
      if (newCol === currColumn) {
        currColumn.isSortedDescending = !currColumn.isSortedDescending;
        currColumn.isSorted = true;
        this.setState({
          announcedMessage: `${currColumn.name} is sorted ${
            currColumn.isSortedDescending ? 'descending' : 'ascending'
          }`,
        });
      } else {
        newCol.isSorted = false;
        newCol.isSortedDescending = true;
      }
    });
    const newItems = _copyAndSort(items, currColumn.fieldName, currColumn.isSortedDescending);
    this.setState({
      columns: newColumns,
      items: newItems,
    });
  };
}

function _copyAndSort(items, columnKey, isSortedDescending) {
  const key = columnKey;;
  return items.slice(0).sort((a, b) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
}

//**//


export default withStyles(style.materialUI)(PartnerTendersList);